import React from 'react';
import styled from 'styled-components';
import TripForm from '../trip-form';
import Title from '../title';
import moment from 'moment';

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import apiService from '../../services/api-service';
import { Modal } from '@mui/material';
import CheckoutForm from '../checkout-form';


const TripFormContainer = styled.div`
    position: absolute;
    top: 150px;
    left: 20px;
    padding: 50px;
    width: 600px;
`;

const FieldLegend = styled.span`
    font-family: 'Montserrat';
    font-size: 1rem;
    font-weight: 700;
    text-transform: uppercase;
`;

const FieldContent = styled.span`
    font-family: 'Montserrat';
    font-size: 1rem;
    font-weight: 200;
    line-height: '25px';
`;

const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-right: 35px;
    width: calc(100% / 3);
`;

const FormButton = styled.button`
    width: auto;
    height: 60px;
    background-color: #06CAFF;
    color: #ffffff;
    font-weight: bold;
    font-family: 'Montserrat';
    text-transform: uppercase;
    padding: 0 50px;
    margin-left: 20px;

    &:hover {
        cursor: pointer;
    }

    &:disabled {
        background-color: #DDDDDD;
        cursor: not-allowed;
    }  
`;

const PreviousButton = styled.button`
    width: auto;
    height: 60px;
    background-color: #676D70;
    color: #ffffff;
    font-weight: bold;
    font-family: 'Montserrat';
    text-transform: uppercase;
    padding: 0 50px;
`;

const FormInput = styled.input`
    width: 100%;
    height: 50px;
    padding: 0 15px;
    font-family: 'Montserrat';
    font-size: 1rem;
    font-weight: 200;
    line-height: 50px;
    border: 1px solid #DDDDDD;
    border-radius: 5px;
    margin-bottom: 20px;
    box-shadow: 1px 1px 20px rgba(200,200,200,0.1);
    outline: none;
    margin-top: 3px;
`;

const WelcomeHeader = () => {

    console.log('----> Welcome Header');

    const [bookingProposal, setBookingProposal] = React.useState(null);
    const [activeStep, setActiveStep] = React.useState(0);
    const [identityForm, setIdentityForm] = React.useState({
        name: '',
        email: '',
        phone: '',
        comment: ''
    });

    const handleBooking = async(tripDetails) => {
        const response = await apiService.calculateTrip({ 
            origin: tripDetails.origin, 
            destination: tripDetails.destination,
            date: tripDetails.date,
            nbPassengers: tripDetails.nbPassengers
        });
        setBookingProposal(response);
    }

    const tripDuration = moment.duration(Number(bookingProposal?.totalDurationSec), 'seconds');

    const validateStep = (step) => {
        if(step === 1) {
            if( !identityForm.name.length || !identityForm.email.length || !identityForm.phone.length ){
                return false;
            }
            return true;
        }
        return true;
    }

    const renderTripDetails = () => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: 'auto',
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    width: '100%',
                    height: 'auto',
                    marginTop: 80
                }}>
                    <FieldContainer>
                        <FieldLegend>
                            Départ
                        </FieldLegend>
                        <FieldContent>
                            { bookingProposal?.origin?.name }
                        </FieldContent>
                        <FieldContent>
                            { moment(bookingProposal?.departureDate).format('DD-MM-YYYY hh:mm') }
                        </FieldContent>
                    </FieldContainer>
                    <FieldContainer style={{
                        alignItems: 'center'
                    }}>
                        <FieldLegend>
                            Temps de trajet
                        </FieldLegend>
                        <FieldContent>
                            { tripDuration.humanize() }
                        </FieldContent>
                    </FieldContainer>
                    <FieldContainer style={{
                        alignItems: 'flex-end'
                    }}>
                        <FieldLegend>
                            Arrivée
                        </FieldLegend>
                        <FieldContent>
                            { bookingProposal?.destination?.name }
                        </FieldContent>
                        <FieldContent>
                            { moment(bookingProposal?.arrival).format('DD-MM-YYYY hh:mm') }
                        </FieldContent>
                    </FieldContainer>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    width: '100%',
                    height: 'auto',
                    marginTop: 50
                }}>
                    <FieldContainer>
                        <FieldLegend>
                            Prix estimé
                        </FieldLegend>
                        <FieldContent>
                            { Math.round(bookingProposal?.cost * 100)/100 } €
                        </FieldContent>
                    </FieldContainer>
                    <FieldContainer style={{
                        alignItems: 'center'
                    }}>
                        <FieldLegend>
                            Passagers
                        </FieldLegend>
                        <FieldContent>
                            { bookingProposal?.nbPassengers }
                        </FieldContent>
                    </FieldContainer>
                    <FieldContainer style={{
                        alignItems: 'flex-end'
                    }}>
                        <FieldLegend>
                            Bagages
                        </FieldLegend>
                        <FieldContent>
                            { bookingProposal?.nbLuggages || 1 }
                        </FieldContent>
                    </FieldContainer>
                </div>
            </div>
        );
    }

    const renderIdentity = () => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: 'auto',
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    width: '100%',
                    height: 'auto',
                    marginTop: 80
                }}>
                    <FieldContainer>
                        <FieldLegend>
                            Nom Prénom
                        </FieldLegend>
                        <div style={{
                            width: '100%',
                            height: 'auto',
                        }}>
                            <FormInput
                                type='text'
                                onChange={(e) => {
                                    setIdentityForm({
                                        ...identityForm,
                                        name: e.target.value
                                    });
                                }}
                            />
                        </div>
                    </FieldContainer>
                    <FieldContainer>
                        <FieldLegend>
                            Email
                        </FieldLegend>
                        <div style={{
                            width: '100%',
                            height: 'auto',
                        }}>
                            <FormInput
                                type='email'
                                onChange={(e) => {
                                    setIdentityForm({
                                        ...identityForm,
                                        email: e.target.value
                                    });
                                }}
                            />
                        </div>
                    </FieldContainer>
                    <FieldContainer>
                        <FieldLegend>
                            Téléphone
                        </FieldLegend>
                        <div style={{
                            width: '100%',
                            height: 'auto',
                        }}>
                            <FormInput
                                type='tel'
                                onChange={(e) => {
                                    setIdentityForm({
                                        ...identityForm,
                                        phone: e.target.value
                                    });
                                }}
                            />
                        </div>
                    </FieldContainer>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    width: '100%',
                    height: 'auto',
                    marginTop: 15
                }}>
                    <FieldContainer style={{
                        width: 'calc((100% / 3) * 2)'
                    }}>
                        <FieldLegend>
                            Commentaire
                        </FieldLegend>
                        <textarea
                            style={{
                                width: '100%',
                                height: '100px',
                                padding: '15px',
                                fontFamily: 'Montserrat',
                                fontSize: '1rem',
                                fontWeight: 200,
                                lineHeight: '25px',
                                border: '1px solid #DDDDDD',
                                borderRadius: '5px',
                                boxShadow: '1px 1px 20px rgba(200,200,200,0.1)',
                                outline: 'none',
                                marginTop: '3px',
                                color: 'black'
                            }}
                            onChange={(e) => {
                                setIdentityForm({
                                    ...identityForm,
                                    comment: e.target.value
                                });
                            }}
                        />
                    </FieldContainer>
                </div>
            </div>
        );
    }

    const renderPayment = () => {
        return (
            <div style={{
                width: '100%',
                height: 'auto',
                marginTop: 80
            }}>
                <CheckoutForm />
            </div>
        )
    }

    return (
        <section 
            className='bg-welcome'
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '1024px',
                width: '100%',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'bottom'
            }}
        >
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
            }}>
                <h1 style={{
                    fontSize: '2rem',
                    fontFamily: 'Bebas Neue',
                    lineHeight: '35px',
                    marginBottom: '25px',
                    color: '#FFFFFF',
                    textShadow: '1px 1px 10px #5B5B5B'
                }}>
                    Réserver un trajet
                </h1>
                { !bookingProposal && (
                    <TripForm
                        onSubmit={handleBooking}
                    />
                )}
                <Modal 
                    open={bookingProposal}
                    onClose={() => setBookingProposal(null)}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        width: '1024px',
                        backgroundColor: 'rgba(255,255,255,1)',
                    }}>
                        <div style={{
                            padding: 80,
                            position: 'relative',
                            width: '100%',
                            maxWidth: '1024px',
                            height: '100%',
                            paddingBottom: 300
                        }}>
                            <div 
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-start',
                                    alignItems: 'flex-start',
                                    width: 'auto',
                                    position: 'absolute',
                                    top: 80,
                                    right: 80,
                                }}
                                onClick={() => setBookingProposal(null)}
                            >
                                <FontAwesomeIcon icon={faXmark} size='2x' />
                            </div>

                            <h1 style={{
                                fontSize: '3rem',
                                fontFamily: 'Bebas Neue',
                                lineHeight: '35px',
                                marginBottom: '25px',
                                color: '#000000',
                                textShadow: '1px 1px 10px #DEDEDE'
                            }}>
                                Votre réservation :
                            </h1>

                            <div style={{
                                width: '100%',
                                height: 'auto',
                            }}>
                                <div style={{
                                    width: '100%',
                                    marginTop: 80
                                }}>
                                    <Stepper activeStep={activeStep} alternativeLabel>
                                        <Step>
                                            <StepLabel>Trajet</StepLabel>
                                        </Step>
                                        <Step>
                                            <StepLabel>Identitée</StepLabel>
                                        </Step>
                                        <Step>
                                            <StepLabel>Paiement</StepLabel>
                                        </Step>
                                        <Step>
                                            <StepLabel>Confirmation</StepLabel>
                                        </Step>
                                    </Stepper>
                                </div>
                            </div>
                            
                            { activeStep === 0 && renderTripDetails() }
                            { activeStep === 1 && renderIdentity() }
                            { activeStep === 2 && renderPayment() }

                            <div style={{
                                position: 'absolute',
                                left: 80,
                                bottom: 80
                            }}>
                                <PreviousButton
                                    onClick={() => {
                                        setActiveStep(activeStep <= 0 ? 0 : activeStep - 1);
                                    }}
                                    disabled={activeStep === 0}
                                >
                                    Précédent
                                </PreviousButton>
                                <FormButton 
                                    onClick={() => {
                                        setActiveStep(activeStep >= 3 ? 0 : activeStep + 1);
                                    }}
                                    disabled={!validateStep(activeStep)}
                                >
                                    Continuer
                                </FormButton>
                            </div>

                            <div style={{
                                position: 'absolute',
                                bottom: 80,
                                right: 80
                            }}>
                                <img 
                                    src={require('../../../assets/images/driver.png')}
                                    alt='driver'
                                    style={{
                                        width: '200px',
                                        height: 'auto'
                                    }}
                                />
                            </div>

                        </div>
                    </div>
                </Modal>
            </div>
        </section>
    );
}

export default WelcomeHeader;